import { render } from "./CreateWithAI.vue?vue&type=template&id=3271c0e4&scoped=true"
import script from "./CreateWithAI.vue?vue&type=script&lang=js"
export * from "./CreateWithAI.vue?vue&type=script&lang=js"

import "./CreateWithAI.vue?vue&type=style&index=0&id=3271c0e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3271c0e4"]])

export default __exports__